import { h, Component } from 'preact';
import { DynamicField } from '../../components/forms/fields/dynamicField/DynamicField';
import { FormFieldTypes } from '../../enums/FormFieldTypes';
import { TextValue } from '../../models/TextValue';
import { BaseComponent } from '../../common/BaseComponent';
import { FormField } from '../../models/FormField';

import { bind, memoize, debounce } from 'decko';

import Dialog from 'preact-material-components/Dialog';
import Button from 'preact-material-components/Button';

//let style = require('./style.css');

export class FormSampleComponent extends BaseComponent<any, any> {

    public value = {};

    constructor(props, ctx) {
        super(props, ctx);
        this.setState({
            fields: [] as FormField[],
            value: {}
        });

    }

    @bind
    public sendToServer() {

    }

    render() {
        var radioOptions: TextValue[] = [{ text: 'option1', value: 1 }, { text: 'option2', value: 2 }, { text: 'option3', value: 3 }] as any;
        return (
            <div style={{ padding: '5px' }} >
                <Dialog ref={this.setRef('dialog')}>
                    <Dialog.Header>Send to Server</Dialog.Header>
                    <Dialog.Body>
                        {this.state.message}
                    </Dialog.Body>
                    <Dialog.Footer>
                        <Dialog.FooterButton accept={true}>Ok</Dialog.FooterButton>
                    </Dialog.Footer>
                </Dialog>
                <div>
                    <h2>Sample form</h2>
                    {this.state.fields ? this.state.fields.map((f, i) => {
                        return <DynamicField fieldType={f.type} label={f.label} value={f.value} options={f.options} onChange={(v) => { this.setState((s) => { s.value[f.name] = v; console.log(f.name, v, s.value); return { value: s.value } }); }} name={f.name}></DynamicField>
                    }) : ("")}
                </div>
                <div>
                    <h3>Result:</h3>
                    {JSON.stringify(this.state.value)}
                </div>
                <div style={{ paddingTop: '15px' }}>
                    <Button ripple raised className="mdc-theme--primary-bg" onClick={this.sendToServer}>
                        Send to server
                    </Button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./routes/formSample/formSample.tsx